import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Flex,
  Heading,
  Button,
  Tooltip,
  Text,
  Input,
  useToast,
} from "@chakra-ui/react";
// import FormControlPhone from "../input/FormControlPhone";
import { useTranslation } from "react-i18next";
import {
  primary,
  white,
  textSecondary,
  textPrimary,
  primaryAlt,
} from "../../../utils/colors";
import { motion } from "framer-motion";
import { updateTenantSupportEmailAction } from "../../../actions/tenantActions";
import { TENANT_UPDATE_SUPPORTEMAIL_RESET } from "../../../constants/tenantConstants";

const MotionFlex = motion(Flex);

const OnboardingStepTwo = ({
  setStep,
  supportEmail,
  setSupportEmail,
  tenant,
}) => {
  const { t } = useTranslation();
  const toast = useToast();

  // TOOLTIP VALIDATION MESSAGES
  const tooltipMessages = [];

  // Email validation: Standard email format
  const isEmailEmpty = supportEmail === "";
  const isEmailInvalid =
    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(supportEmail) &&
    !isEmailEmpty;

  // Email error messages
  if (isEmailEmpty) {
    tooltipMessages.push(t("onboarding.enterSenderIdentityEmail"));
  } else if (isEmailInvalid) {
    tooltipMessages.push(t("onboarding.enterValidSenderIdentityEmail"));
  }

  // REDUX
  const dispatch = useDispatch();

  const tenantUpdateSupportEmail = useSelector(
    (state) => state.tenantUpdateSupportEmail
  );
  const {
    loading: loadingUpdateSupportEmail,
    error: errorUpdateSupportEmail,
    success: successUpdateSupportEmail,
  } = tenantUpdateSupportEmail;

  // HANDLERS

  const handleSubmit = (event) => {
    event.preventDefault(); // Prevent the default form submission via HTTP

    dispatch(updateTenantSupportEmailAction(supportEmail, tenant.slug));
  };

  // USE EFFECT
  useEffect(() => {
    if (successUpdateSupportEmail) {
      setStep(2);

      dispatch({ type: TENANT_UPDATE_SUPPORTEMAIL_RESET });
    } else if (errorUpdateSupportEmail) {
      toast({
        title: t("toasts.onboardingUpdateSupportEmailError"),
        status: "error",
        duration: 9000,
        isClosable: true,
      });

      dispatch({ type: TENANT_UPDATE_SUPPORTEMAIL_RESET });
    }
  }, [successUpdateSupportEmail, errorUpdateSupportEmail]);

  // LOGS
  // console.log("senderIdentityEmail", senderIdentityEmail);
  // console.log("isEmailEmpty", isEmailEmpty);
  // console.log("isEmailInvalid", isEmailInvalid);
  // console.log("supportEmail", supportEmail);

  return (
    <>
      <form onSubmit={handleSubmit}>
        <MotionFlex
          key="step2"
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -50, opacity: 0 }}
          transition={{ duration: 0.5 }}
        >
          <Flex
            direction="column"
            align={["flex-start", "center"]}
            justify={["flex-start", "center"]}
            p={["0 1.5rem", "4rem"]}
            maxW={["100%", "800px"]}
          >
            <Heading
              fontSize={["2.5rem", "3rem"]}
              textAlign={["left", "center"]}
              maxW="100%"
              lineHeight={["1.2", "initial"]}
            >
              {t("onboarding.questionTwo")}
            </Heading>

            <Flex aling="center" mt={4} maxW={["100%", "90%"]}>
              <Text
                fontSize={["1.125rem", "1rem"]}
                fontWeight="500"
                textAlign={["left", "center"]}
                color={textSecondary}
              >
                {t("onboarding.questionTwoText")}
              </Text>
            </Flex>

            <Flex
              gap={[2, 4]}
              align={["flex-start", "center"]}
              justify="center"
              p="2rem 0 2rem"
              w="100%"
              direction="column"
            >
              <Text fontSize="md" fontWeight="500" color={textPrimary}>
                {t("onboarding.enterSenderIdentityEmail")}
              </Text>

              <Input
                autoFocus
                size="lg"
                h={["3.5rem", "4rem"]}
                fontSize="lg"
                bg="white"
                fontWeight="500"
                borderRadius="10rem"
                onChange={(e) => setSupportEmail(e.target.value)}
                value={supportEmail}
                placeholder=""
                textAlign="center"
                maxW={["100%", "600px"]}
                textTransform="lowercase"
                _focus={{
                  borderColor: primary,

                  boxShadow: "none",
                }}
              />
            </Flex>

            <Flex align="center" justify="center" w="100%" gap={4}>
              <Tooltip
                placement="top"
                p="0.25rem 1rem"
                fontSize="xs"
                borderRadius="1rem"
                label={
                  tooltipMessages.length > 0 ? (
                    <Flex direction="column" justify="center" align="center">
                      {tooltipMessages.map((message, index) => (
                        <Text
                          key={index}
                          // color={buttonRedText}

                          fontWeight="500"
                          textAlign="center"
                        >
                          {message}
                        </Text>
                      ))}
                    </Flex>
                  ) : null
                }
                isDisabled={tooltipMessages.length === 0} // Disable tooltip if no errors
              >
                <Button
                  type="submit"
                  h="3.5rem"
                  size="lg"
                  borderRadius="10rem"
                  // onClick={next}
                  onClick={handleSubmit}
                  isLoading={loadingUpdateSupportEmail}
                  bg={textPrimary}
                  px={["1.5rem", "3rem"]}
                  minW={["100%", "10rem"]}
                  color={white}
                  transition="all 0.3s ease"
                  _hover={{
                    bg: primaryAlt,
                    color: white,
                  }}
                  // isDisabled={!modules.some((m) => m.isActive)}
                  // _disabled={{
                  //   cursor: "pointer",
                  //   opacity: "0.8",
                  // }}
                  isDisabled={tooltipMessages.length > 0} // Disable if any errors exist

                  // isDisabled={isPhoneError || loadingUpdatePhone}
                  // isLoading={loadingUpdatePhone}
                >
                  {t("onboarding.continue")}
                </Button>
              </Tooltip>
            </Flex>
          </Flex>
        </MotionFlex>
      </form>
    </>
  );
};

export default OnboardingStepTwo;
